<template>
  <div>
    <heading class="mb-3" :level="1" size="sm">{{ bp('containerUpdate') }}</heading>
    <div
      v-for="(container, index) in dropShipContainer.containers"
      :key="index"
      class="flex items-start justify-between mb-3"
    >
      <ContainerIndicator
        :base-properties="baseProperties"
        :container="container"
        :drop-ship-container="dropShipContainer"
      />
      <div class="flex items-center ml-6">
        <span class="text-md mr-2">{{ bp('quantity') }}</span>
        <input
          v-model.number="containersAmount[container.type]"
          type="number"
          class="form-control w-12"
          :class="{'border border-red': errorMessage}"
        />
      </div>
    </div>
    <pdl-callout v-if="errorMessage" class="max-w-xs" kind="error" qaid="containerConfigurationWarning">
      <template #content>
        <span v-html="errorMessage" />
      </template>
    </pdl-callout>
    <div class="buttons">
      <trek-button
        primary
        block
        :disabled="errorMessage"
        qaid="containerConfigurationConfirmButton"
        @click="submitContainers"
      >
        <span v-html="bp('containerConfirm')"></span>
      </trek-button>
    </div>
    <div class="buttons">
      <trek-button secondary block qaid="containerConfigurationCloseButton" @click="$emit('close')">
        <span v-html="bp('cancel')"></span>
      </trek-button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import get from 'lodash/get';
import {mapActions} from 'vuex';
import TrekButton from '@/components/TrekButton';
import {PdlCallout} from '@pedal/pdl-callout';
import Heading from '@/components/Heading';

export default {
  name: 'ContainerConfiguration',

  components: {
    ContainerIndicator: () => import('@/components/containers/drop-ship/ContainerIndicator'),
    PdlCallout,
    Heading,
    TrekButton,
  },

  props: {
    baseProperties: {
      type: Array,
      default: () => [],
    },
    dropShipContainer: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      responseErrorMessage: null,
      containersAmount: {},
    };
  },

  computed: {
    errorMessage() {
      if (this.responseErrorMessage) {
        return this.responseErrorMessage;
      } else if (Object.values(this.containersAmount).reduce((a, b) => a + b) < 1) {
        return this.bp('errorSelectOne');
      } else if (Object.values(this.containersAmount).reduce((a, b) => a + b) > 15) {
        return this.bp('maxContainer');
      }

      return null;
    },
  },

  watch: {
    dropShipContainer: {
      immediate: true,
      handler() {
        this.resetState();
      },
    },
  },

  methods: {
    resetState() {
      this.responseErrorMessage = null;
      this.dropShipContainer.containers.forEach((container) =>
        this.$set(this.containersAmount, container.type, container.totals.amount)
      );
    },

    submitContainers() {
      const payload = {
        containerQtyFortyHi: this.containersAmount['FORTY_HI_FEET'],
        containerQtyForty: this.containersAmount['FORTY_FEET'],
        containerQtyTwenty: this.containersAmount['TWENTY_FEET'],
      };

      this.responseErrorMessage = null;

      axios
        .put('/containers', payload)
        .then((response) => {
          const status = get(response, 'data.meta.feedback.type');
          if (status === 'success') {
            this.$emit('close');
            this.fetchMiniCart();
            this.fetchCart();
          } else if (status === 'alert') {
            this.responseErrorMessage = get(response, 'data.meta.feedback.message.basePropertyValue');
          } else {
            this.responseErrorMessage = this.bp('tryAgain');
          }
        })
        .catch((error) => {
          this.responseErrorMessage = this.bp('tryAgain');
          console.log(error);
        });
    },

    ...mapActions('cart', ['fetchCart']),
    ...mapActions('miniCart', ['fetchMiniCart']),
  },
};
</script>
